module.exports = __webpack_public_path__ + "public/files/img/loading-bar.a1275573.svg";